import ListingSetting from 'Entity/Collection/ListingSetting';
import CardData from 'Entity/Collection/ListingSetting/View/CardData';
import React, { useContext, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCardSettings } from 'Vendor/Context/CardSettingsContext';
import { UserContext } from 'Vendor/Context/UserContextProvider';

interface _FilterCardProps {
    setting: ListingSetting;
}

const _FilterCard: React.FC<_FilterCardProps> = ({ setting }) => {
    const { t } = useTranslation();
    const cardDatas = setting.cardDatas;
    const { toggleSetting, isSettingSelected, setSelectedSettings, toggleDisplaySetting, isDisplaySettingSelected } = useCardSettings();
    const { currentUser } = useContext(UserContext);
    const defaultLanguage = currentUser?.currentOrganization?.defaultLanguage as string;

    useEffect(() => {
        const allValues = cardDatas.filter((item: CardData) => item.property).map((item: CardData) => item?.property?.slug ?? '');
        setSelectedSettings(allValues);
    }, [cardDatas, setSelectedSettings]);

    const cardSettingsOptions = cardDatas.map((item: CardData) => ({
        label: item.property?.translations?.[defaultLanguage]?.label ?? '',
        value: item.property?.slug ?? '',
    }));

    return (
        <Dropdown autoClose="outside">
            <Dropdown.Toggle variant="secondary">
                {t('app.properties')}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {setting.cardShowVersion && <Dropdown.Item active={isDisplaySettingSelected('showVersion')} onClick={() => toggleDisplaySetting('showVersion')}>
                    {t('app.version')}
                </Dropdown.Item>}
                {setting.cardShowSchedule && <Dropdown.Item active={isDisplaySettingSelected('showSchedule')} onClick={() => toggleDisplaySetting('showSchedule')}>
                    {t('app.dates')}
                </Dropdown.Item>}
                {setting.cardShowSizeAndWeight && <Dropdown.Item active={isDisplaySettingSelected('showSizeAndWeight')} onClick={() => toggleDisplaySetting('showSizeAndWeight')}>
                    {t('app.sizeAndWeight')}
                </Dropdown.Item>}
                {setting.cardShowBadge && <Dropdown.Item active={isDisplaySettingSelected('showBadge')} onClick={() => toggleDisplaySetting('showBadge')}>
                    {t('app.badge')}
                </Dropdown.Item>}
                {setting.cardShowStatus && <Dropdown.Item active={isDisplaySettingSelected('showStatus')} onClick={() => toggleDisplaySetting('showStatus')}>
                    {t('app.status')}
                </Dropdown.Item>}
                {cardSettingsOptions
                    .filter((option) => (option.value || option.label))
                    .map((option) => (
                        <Dropdown.Item
                            key={option.value}
                            onClick={() => toggleSetting(option.value)}
                            active={isSettingSelected(option.value)}
                            className="d-flex justify-content-between"
                        >
                            <span>{option.label}</span>
                        </Dropdown.Item>
                    ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default _FilterCard;
